module.exports = __webpack_public_path__ + "img/es.c385370.svg";